module.exports = __webpack_public_path__ + "media/images/common/ui/btn_keirin-5820b0d26dea996fa370465455e0cb97.png";